module.exports = __webpack_public_path__ + "static/media/add-logo-tabletPro-en.45f1e41b.png";